import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { ComercialPagedModel, ComercialPagedRequestModel } from '../../models/comercial/comercial-paged.model';
import { ComercialRepository } from '../../repositories/comercial.repository';

export class GetComercialPagedUseCase implements UseCase<ComercialPagedRequestModel, ComercialPagedModel> {
  constructor(private comercialRepository: ComercialRepository) {}

  execute(params: ComercialPagedRequestModel): Observable<ComercialPagedModel> {
    return this.comercialRepository.getComercialPaged(params);
  }
}
